module.exports = __webpack_public_path__ + "static/media/master.59005030.png";